var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceSubscriptionRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M28.68 11.322v22.374A2.304 2.304 0 0 1 26.374 36h-15.07A2.316 2.316 0 0 1 9 33.696V6.304A2.304 2.304 0 0 1 11.304 4h10.054l7.321 7.322z",
    fill: "url(#2xeaad596a)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.408 36h-3.104A2.316 2.316 0 0 1 9 33.696V6.304A2.304 2.304 0 0 1 11.304 4h3.104a2.292 2.292 0 0 0-2.305 2.304v27.392A2.304 2.304 0 0 0 14.408 36z",
    fill: "url(#80dkmi97sb)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.46 4v7.322h7.304L24.461 4z",
    fill: "url(#fv6akpb1oc)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.764 11.322 24.442 4H11.304A2.304 2.304 0 0 0 9 6.304v27.392A2.304 2.304 0 0 0 11.304 36h18.174a2.304 2.304 0 0 0 2.305-2.304V11.322h-.019zm0 0h-7.303V4l7.303 7.322zm-16.539 1.914h3.605m-3.605-3.382h3.605m-3.605 10.22h9.682m-9.682 4.98h9.682m-9.682 5.427h9.682",
    stroke: "url(#pclcrdo96d)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2xeaad596a",
    x1: 9,
    y1: 22.608,
    x2: 29.772,
    y2: 18.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "80dkmi97sb",
    x1: 9,
    y1: 22.608,
    x2: 14.92,
    y2: 22.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fv6akpb1oc",
    x1: 24.461,
    y1: 8.258,
    x2: 31.711,
    y2: 5.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pclcrdo96d",
    x1: 9,
    y1: 22.608,
    x2: 32.734,
    y2: 17.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSubscriptionRequest);
export default __webpack_public_path__ + "static/media/serviceSubscriptionRequest.6ba889d49e2350c8486220033c4c7b07.svg";
export { ForwardRef as ReactComponent };